import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateAfterControlValidator(
	control: AbstractControl,
	onlyAfter: boolean = false,
	basicFormat: boolean = false
): (innerControl: AbstractControl) => ValidationErrors | null {
	return (innerControl: AbstractControl): ValidationErrors | null => {
		if (control.value && innerControl.value) {
			const input = basicFormat ? basicFormatToDate(innerControl.value) : new Date(innerControl.value);
			const after = basicFormat ? basicFormatToDate(control.value) : new Date(control.value);

			if (onlyAfter) {
				if (input <= after) {
					return {
						after: true,
					};
				}
			} else {
				if (input < after) {
					return {
						after: true,
					};
				}
			}
		}

		return null;
	};
}

function basicFormatToDate(basic: string): Date {
	// DD/MM/YYYY
	const regex = /([0-3][0-9])\/([0-1][0-9])\/([0-9]{4})/;
	const result = regex.exec(basic);

	if (result) {
		const [_, day, month, year] = result;
		return new Date(+year, +month - 1, +day);
	}

	return new Date();
}
